<template>
  <aside>
    <TypographyConfig/>
    <ColorSwatch/>
  </aside>
</template>

<script>

import ColorSwatch from "@/components/SideEditor/BlockConfiguration/ColorSwatch/ColorSwatch"
import TypographyConfig from "@/components/SideEditor/BlockConfiguration/TypographyConfig/TypographyConfig"

export default {
  components: {
    TypographyConfig,
    ColorSwatch,
  },
}

</script>
